var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0183 11.3024L15.9 10.1841C15.766 10.0657 15.6583 9.92052 15.5841 9.75785C15.5099 9.59519 15.4707 9.41872 15.4692 9.23992C15.4508 8.82742 15.6158 8.41492 15.9183 8.11242L17.0183 7.01242C17.9717 6.05909 18.3292 5.14242 18.0267 4.41825C17.7333 3.70325 16.8258 3.30909 15.4875 3.30909H5.90833V2.52075C5.90833 2.14492 5.59666 1.83325 5.22083 1.83325C4.84499 1.83325 4.53333 2.14492 4.53333 2.52075V19.4791C4.53333 19.8549 4.84499 20.1666 5.22083 20.1666C5.59666 20.1666 5.90833 19.8549 5.90833 19.4791V15.0058H15.4875C16.8075 15.0058 17.6967 14.6024 17.9992 13.8783C18.3017 13.1541 17.9533 12.2466 17.0183 11.3024Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c662e61127ef91ae35dc39e15dbe0b27.svg";
export { ForwardRef as ReactComponent };